__turbopack_context__.v({
  "alignCenter": "index-module-scss-module__r36m4G__alignCenter",
  "alignEnd": "index-module-scss-module__r36m4G__alignEnd",
  "alignStart": "index-module-scss-module__r36m4G__alignStart",
  "blue": "index-module-scss-module__r36m4G__blue",
  "body": "index-module-scss-module__r36m4G__body",
  "fs10": "index-module-scss-module__r36m4G__fs10",
  "fs12": "index-module-scss-module__r36m4G__fs12",
  "fs20": "index-module-scss-module__r36m4G__fs20",
  "fs32": "index-module-scss-module__r36m4G__fs32",
  "fs36": "index-module-scss-module__r36m4G__fs36",
  "green": "index-module-scss-module__r36m4G__green",
  "grey": "index-module-scss-module__r36m4G__grey",
  "greyLight": "index-module-scss-module__r36m4G__greyLight",
  "huge": "index-module-scss-module__r36m4G__huge",
  "large": "index-module-scss-module__r36m4G__large",
  "medium": "index-module-scss-module__r36m4G__medium",
  "p": "index-module-scss-module__r36m4G__p",
  "purple": "index-module-scss-module__r36m4G__purple",
  "red": "index-module-scss-module__r36m4G__red",
  "small": "index-module-scss-module__r36m4G__small",
  "textCenter": "index-module-scss-module__r36m4G__textCenter",
  "themeColor": "index-module-scss-module__r36m4G__themeColor",
  "underlined": "index-module-scss-module__r36m4G__underlined",
  "w500": "index-module-scss-module__r36m4G__w500",
  "w600": "index-module-scss-module__r36m4G__w600",
  "w700": "index-module-scss-module__r36m4G__w700",
  "w800": "index-module-scss-module__r36m4G__w800",
  "white": "index-module-scss-module__r36m4G__white",
});
